/**
 * Flatten the `child.modules` view object into the `[{nicheModelName,
 * nicheItemId}]` shape `useResolveCustomDefaults` expects. The server
 * walks FK relations on those primary niches (e.g. `course.universityId
 * → university`), so we only need the top-level entries — virtual
 * sub-fields (qualification, specialization, etc.) shouldn't be added
 * here or the resolver will double-count.
 *
 * Shared by the Preference card's view (inline editing) and edit modes so
 * both narrow a deal's custom-field options identically.
 */
export function getChildModuleScopes(
  child: any,
): { nicheModelName: string; nicheItemId: number }[] {
  if (!child?.modules) return [];
  const out: { nicheModelName: string; nicheItemId: number }[] = [];
  const seen = new Set<string>();
  const push = (item: any) => {
    if (!item || typeof item !== "object") return;
    const id = Number(item.id);
    const model = typeof item.model === "string" ? item.model : null;
    if (!Number.isFinite(id) || !model) return;
    const key = `${model}:${id}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push({ nicheModelName: model, nicheItemId: id });
  };
  const buckets = ["ONE_TO_ONE", "ONE_TO_MANY", "MANY_TO_MANY"] as const;
  for (const bucketKey of buckets) {
    const bucket = (child.modules as Record<string, unknown>)?.[bucketKey];
    if (!bucket || typeof bucket !== "object") continue;
    for (const slot of Object.values(bucket as Record<string, unknown>)) {
      if (Array.isArray(slot)) for (const it of slot) push(it);
      else push(slot);
    }
  }
  return out;
}

export default getChildModuleScopes;
